import { Button } from '@/components/common/Button';
import { DialogWrapper } from '@/components/common/DialogWrapper';
import { RelationActionButton } from '@/components/common/RelationActionButton';
import type { ReactNode } from 'react';

export interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: ReactNode;
  onConfirm: () => void;
  isPending?: boolean;
}

export function ConfirmDeleteDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  isPending,
}: ConfirmDeleteDialogProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <DialogWrapper
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      maxWidth="md"
    >
      <div className="mt-4 flex flex-col gap-6">
        <p className="text-base">{description}</p>
        <p className="text-muted-foreground text-sm">
          This action cannot be undone.
        </p>

        <div className="flex items-center justify-between gap-4">
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? 'Deleting...' : 'Delete'}
          </Button>
          <RelationActionButton
            type="button"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </RelationActionButton>
        </div>
      </div>
    </DialogWrapper>
  );
}
